module.exports = __webpack_public_path__ + "img/novo.2a1f36ce.svg";